<template>
  <div class="row">
    <div class="col-9 m-auto">
      <div :id="item" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item" v-for="i in images">
            <img class="d-block w-100" :src="require('../assets/images/' + item + '/' + i)" alt="First slide">
          </div>
        </div>
        <a class="carousel-control-prev" :href="'#' + item" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" :href="'#' + item" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['images', 'item'],
    name: "Carousel",
    mounted: function () {
      this.$nextTick(function () {
        let items = document.getElementsByClassName('carousel-inner');

        if (items.length > 0) {
          for (let i of items) {
            i.getElementsByClassName('carousel-item')[0].classList.add('active');
          }
        }
      })
    },
  }
</script>

<style scoped>

</style>